module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpanded.afa0da0.ttf";